import { format } from 'date-fns';

const formatTime = (date: string) => format(new Date(date), 'MMM d, hh:mm:ss a');

export default formatTime;
